import personalizeService from '../utils/rbmc.personalizeService';
import logger from '../utils/rbmc.logger';
import cookieUtils from '../utils/rbmc.cookie-utils';
import urlUtils from '../utils/rbmc.url-utils';
import gigyaLiteRegistration from "../gigya/rbmc.lite-registration";

const subscribeNewsletter = {
    TYPE_CONTEST: 'contest',
    bindHandler() {
        $('#subscribe-newsletter').on('click', (evt) => {
            let $self = $(evt.currentTarget);
            let value = $self.prev().val();
            const $newsletterEmailInput = $('.page-footer__newsletter-input');

            if (value === '') {
                return;
            }

            const subscriptionStatus = gigyaLiteRegistration.fetchSubscriptionData($newsletterEmailInput.val());
            subscriptionStatus.done((response) => {
                if (!response.allowSubscription) {
                    gigyaLiteRegistration.alreadySubscribedActions(response, $newsletterEmailInput);
                } else {
                    var emailEncoded = encodeURIComponent(value);
                    window.location  = ACC.config.encodedContextPath + '/newsletter/get-subscribed?email=' + emailEncoded;
                }
            });
        });

        /**
         * Set right redirect back to homepage link
         */

        $('.newsletter__back-button').attr('href', `${urlUtils.getBaseUrl()}`)
    },

    changeBannerIfContest() {
        const nlConfirmationPage    = $('.page-newsletterConfirmationPage');
        const newsletterTypeFromUrl = new URL(window.location.href).searchParams.get('type');
        const $banner               = $('.banner');
        const $bannerNormal         = $banner.find('.banner__text--normal');
        const $bannerContest        = $banner.find('.banner__text--contest');
        const $bannerContent        = $('.newsletter__content').find('.banner__text--contest');

        if (nlConfirmationPage.length && newsletterTypeFromUrl === subscribeNewsletter.TYPE_CONTEST) {
            $bannerNormal.addClass('d-none');
            $bannerContest.removeClass('d-none');
            $bannerContent.removeClass('d-none');
        } else {
            $bannerNormal.removeClass('d-none');
            $bannerContest.addClass('d-none');
        }
    },

    newsletterConfirmationInStoreBack() {
        const nlInStoreConfirmation = $('.page-newsletterSubcribeInStoreConfirmationPage');
        const backToFormBtn         = nlInStoreConfirmation.find('.newsletter__back-button');
        const previousStoreId       = window.localStorage.getItem('storeId');

        if (nlInStoreConfirmation.length) {
            if (previousStoreId !== undefined) {
                backToFormBtn.attr('href', `${urlUtils.getBaseUrl()}newsletter/subscribe-in-store/?storeid=${previousStoreId}`);
            }
        }
    }
};

$(() => {
    subscribeNewsletter.bindHandler();
    subscribeNewsletter.newsletterConfirmationInStoreBack();
    subscribeNewsletter.changeBannerIfContest();
});

export default subscribeNewsletter;
